import { Capacitor } from "@capacitor/core";

// One-shot App Store rating prompt (native only). Fired after the user
// follows their FIRST truck — a natural "this app just did its job"
// moment. iOS/Android decide whether the dialog actually appears
// (SKStoreReviewController / Play In-App Review throttle internally),
// so calling once per device is safe.
const KEY = "tt:app-review-prompted";

export function maybeRequestAppReview() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    if (localStorage.getItem(KEY)) return;
    localStorage.setItem(KEY, String(Date.now()));
  } catch {
    return;
  }
  // Let the follow confirmation toast land first.
  setTimeout(async () => {
    try {
      const { InAppReview } = await import("@capacitor-community/in-app-review");
      await InAppReview.requestReview();
    } catch {
      /* plugin not in this binary yet — no-op until next app update */
    }
  }, 2500);
}
